/* eslint-disable */
import React from 'react';
import { Row, Col } from 'react-bootstrap';
import ResultsTab from './ResultsTab';
import _ from 'underscore';
import './Search.sass';
import SearchInstructionsModalContainer from './searchInstructionsModalContainer';
const possibleTags = [
  'questionid',
  'chapterid',
  'referenceid',
  'enabled',
  'softwarepage',
  'status',
  'flashmode',
  'archived',
  'actasparent',
  'isghostchapter',
  'documentpage',
];

class Search extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      options: this.props.options,
      requestSent: false,
      internalQueryError: false,
    };
  }

  componentWillMount() {
    this.props.setIsSearchingBooks(false);
    this.props.setIsSearchingChapters(false);
    this.props.setIsSearchingQuestions(false);
    this.props.setSearchSuccess(false);
    this.props.setSearchError(false);
    this.props.setErrors([]);
    if (this.props.query !== '' && this.props.searchFromHeader) {
      this.validate();
    }
  }

  /* function for validate fields before dispatch */
  // IS only called from search bar. for individual searches, we must use pagination
  validate = () => {
    //prevent to send an empty query to API
    if (this.props.query === '') {
      this.setState({ internalQueryError: true });
    } else {
      let query = this.props.query.trim().replace(/\s+/g, ' ').toLowerCase();

      // Unified regex for all tags (quoted or not)
      const tagRegex = /[a-z]{2,20}\s*:\s*("[^"]*"|[a-z0-9.-_]+)/g;
      const tagsArray = query.match(tagRegex);

      if (tagsArray) {
        query = query.replace(tagRegex, '');
      }

      // Clean up leftover commas from the query string before trimming
      query = query.replace(/,/g, ' ').replace(/\s+/g, ' ').trim();

      const separatedTags = this.getTags(tagsArray);

      this.props.setOptions(this.state.options);
      this.setState({ internalQueryError: false, requestSent: true });
      if (this.state.options === 'All' || this.state.options === 'Books') {
        this.props.setBooksResponse({ books: [], count: 0 });
        this.props.submitBooksSearch(query, separatedTags, 0, false);
      }
      if (this.state.options === 'All' || this.state.options === 'Questions') {
        this.props.setQuestionsResponse({ questions: [], count: 0 });
        this.props.submitQuestionsSearch(query, separatedTags, 0, false);
      }
      if (this.state.options === 'All' || this.state.options === 'Chapters') {
        this.props.setChaptersResponse({ chapters: [], count: 0 });
        this.props.submitChaptersSearch(query, separatedTags, 0, false);
      }
    }
  };

  loadMore = (option) => {
    let query = this.props.query.trim().replace(/\s+/g, ' ').toLowerCase();

    // Unified regex for all tags (quoted or not)
    const tagRegex = /[a-z]{2,20}\s*:\s*("[^"]*"|[a-z0-9.-_]+)/g;
    const tagsArray = query.match(tagRegex);

    if (tagsArray) {
      query = query.replace(tagRegex, '');
    }

    // Clean up leftover commas from the query string before trimming
    query = query.replace(/,/g, ' ').replace(/\s+/g, ' ').trim();

    const separatedTags = this.getTags(tagsArray);

    if (option === 'All' || option === 'Books') {
      this.props.submitBooksSearch(
        query,
        separatedTags,
        this.props.booksResponse.books.length,
        true,
      );
    }
    if (option === 'All' || option === 'Questions') {
      this.props.submitQuestionsSearch(
        query,
        separatedTags,
        this.props.questionsResponse.questions.length,
        true,
      );
    }
    if (option === 'All' || option === 'Chapters') {
      this.props.submitChaptersSearch(
        query,
        separatedTags,
        this.props.chaptersResponse.chapters.length,
        true,
      );
    }
  };

  clearAll = () => {
    this.props.setIsSearchingBooks(false);
    this.props.setIsSearchingChapters(false);
    this.props.setIsSearchingQuestions(false);
    this.props.setSearchSuccess(false);
    this.props.setSearchError(false);
    this.props.setErrors([]);
    this.props.setBooksResponse({ books: [], count: 0 });
    this.props.setQuestionsResponse({ questions: [], count: 0 });
    this.props.setChaptersResponse({ chapters: [], count: 0 });
    this.props.setOptions('All');
    this.props.setQuery('');
    this.setState({ requestSent: false });
  };

  getTags = (tagsArray) => {
    //If the user inserts at least one correct tag, It will be on the response
    //If there isn't any correct tag, the response it will be an empty array
    //All incorrect tags will be eliminated

    let separatedTags = [];

    // Helper to clean up tag strings
    const clean = (str) =>
      str
        .trim()
        .replace(/^[,"]+|[,"]+$/g, '')
        .trim();

    if (tagsArray?.length > 0) {
      tagsArray.forEach((tag) => {
        // Allow spaces around colon, and remove extra commas
        const splitted = tag.split(':');
        if (splitted.length >= 2) {
          const tagId = clean(splitted[0].toLowerCase());
          // Join the rest of the split array in case the value had a colon
          const tagContent = clean(splitted.slice(1).join(':'));
          separatedTags.push({ tagId, tagContent });
        }
      });

      // Remove invalid tags
      let invalidTags = [];
      separatedTags.forEach((tag) => {
        if (!possibleTags.includes(tag.tagId)) {
          invalidTags.push(tag);
        }
      });

      separatedTags = _.difference(separatedTags, invalidTags);
      invalidTags = [];

      // Validate data types
      separatedTags.forEach((tag) => {
        if (
          tag.tagId === 'questionid' ||
          tag.tagId === 'chapterid' ||
          tag.tagId === 'referenceid' ||
          tag.tagId === 'softwarepage'
        ) {
          const value = Number(tag.tagContent);
          if (isNaN(value)) {
            invalidTags.push(tag);
          }
        }

        if (
          tag.tagId === 'archived' ||
          tag.tagId === 'flashmode' ||
          tag.tagId === 'enabled' ||
          tag.tagId === 'isghostchapter' ||
          tag.tagId === 'actasparent'
        ) {
          if (!(tag.tagContent === 'true' || tag.tagContent === 'false')) {
            invalidTags.push(tag);
          }
        }

        if (tag.tagId === 'status') {
          if (
            !(
              tag.tagContent === 'published' ||
              tag.tagContent === 'new' ||
              tag.tagContent === 'edit' ||
              tag.tagContent === 'delete'
            )
          ) {
            invalidTags.push(tag);
          }
        }
      });

      separatedTags = _.difference(separatedTags, invalidTags);
    }

    return separatedTags;
  };

  keyPressed = (event) => {
    if (event.key === 'Enter') {
      this.validate();
    }
  };

  openInstructionsModal = () => {
    this.props.openModal({
      modalContent: (
        <SearchInstructionsModalContainer onCancel={this.props.closeModal} />
      ),
      modalClassName: 'instructionsModal',
    });
  };

  render() {
    return (
      <div className="search-page">
        <div className="search-page-container">
          <Row className="searchBarRow">
            {/* for searchBar */}
            <Col sm={12} md={12} lg={8} className="searchBarContainer">
              <div className="form-inline">
                <i
                  className="fa fa-question-circle fa-lg"
                  onClick={this.openInstructionsModal}
                />
                <input
                  type="text"
                  value={this.props.query}
                  className={
                    this.state.internalQueryError
                      ? 'form-control searchBar red-border'
                      : 'form-control searchBar'
                  }
                  placeholder="Search"
                  onKeyPress={this.keyPressed}
                  onChange={(e) => this.props.setQuery(e.target.value)}
                />
                <select
                  className="form-control selector"
                  value={this.state.options}
                  onChange={(e) => this.setState({ options: e.target.value })}
                >
                  <option value="All">All</option>
                  <option value="Books">Books</option>
                  <option value="Chapters">Chapters</option>
                  <option value="Questions">Questions</option>
                </select>
                <button className="btn btn-primary" onClick={this.validate}>
                  <i className="fa fa-search fa-lg" />
                </button>
              </div>
            </Col>
          </Row>
          {!(
            this.props.booksResponse.books.length > 0 ||
            this.props.chaptersResponse.chapters.length > 0 ||
            this.props.questionsResponse.questions.length > 0
          ) && (
            <Row className="indicatorsRow">
              {/* for search indicators */}
              {!this.props.isSearching &&
                !this.props.searchSuccess &&
                !this.props.searchError &&
                !this.state.requestSent && (
                  <Col className="searchIndicator">
                    <i className="fa fa-search fa-lg" />
                    <span className="searchIndicatorText">
                      Type your search term above
                    </span>
                  </Col>
                )}
              {!this.props.isSearchingBooks &&
                !this.props.isSearchingChapters &&
                !this.props.isSearchingQuestions &&
                this.props.booksResponse.books.length == 0 &&
                this.props.chaptersResponse.chapters.length == 0 &&
                this.props.questionsResponse.questions.length == 0 &&
                this.state.requestSent && (
                  <Col className="notFoundMessage">
                    <i className="fa fa-close fa-lg" />
                    <span className="searchIndicatorText">
                      Oops! No Results Found
                    </span>
                    <span className="searchIndicatorText text-muted">
                      Please check your request
                    </span>
                  </Col>
                )}
            </Row>
          )}
          {(this.props.booksResponse.books.length > 0 ||
            this.props.chaptersResponse.chapters.length > 0 ||
            this.props.questionsResponse.questions.length > 0 ||
            this.props.isSearchingBooks ||
            this.props.isSearchingChapters ||
            this.props.isSearchingQuestions) && (
            <Row className="resultsRow">
              {!this.props.isSearchingBooks &&
                !this.props.isSearchingChapters &&
                !this.props.isSearchingQuestions && (
                  <div className="clear-all-container">
                    <div className="badge badge-pill" onClick={this.clearAll}>
                      CLEAR ALL
                      <span aria-hidden="true" className="closeButton">
                        &times;
                      </span>
                    </div>
                  </div>
                )}
              {(this.props.options === 'All' ||
                this.props.options === 'Books') &&
                this.props.booksResponse.books && (
                  <ResultsTab
                    title="Books"
                    resultSize={
                      this.props.booksResponse.books
                        ? this.props.booksResponse.books.length
                        : 0
                    }
                    items={
                      this.props.booksResponse.books
                        ? this.props.booksResponse.books
                        : []
                    }
                    searching={this.props.isSearchingBooks}
                    loadMore={() => this.loadMore('Books')}
                    count={
                      this.props.booksResponse.count
                        ? Number(this.props.booksResponse.count)
                        : 0
                    }
                    query={this.props.query}
                  />
                )}
              {(this.props.options === 'All' ||
                this.props.options === 'Chapters') &&
                this.props.chaptersResponse.chapters && (
                  <ResultsTab
                    title="Chapters"
                    resultSize={
                      this.props.chaptersResponse.chapters
                        ? this.props.chaptersResponse.chapters.length
                        : 0
                    }
                    items={
                      this.props.chaptersResponse.chapters
                        ? this.props.chaptersResponse.chapters
                        : []
                    }
                    searching={this.props.isSearchingChapters}
                    loadMore={() => this.loadMore('Chapters')}
                    count={
                      this.props.chaptersResponse.count
                        ? Number(this.props.chaptersResponse.count)
                        : 0
                    }
                    query={this.props.query}
                  />
                )}
              {(this.props.options === 'All' ||
                this.props.options === 'Questions') &&
                this.props.questionsResponse.questions && (
                  <ResultsTab
                    title="Questions"
                    resultSize={
                      this.props.questionsResponse.questions
                        ? this.props.questionsResponse.questions.length
                        : 0
                    }
                    items={
                      this.props.questionsResponse.questions
                        ? this.props.questionsResponse.questions
                        : []
                    }
                    searching={this.props.isSearchingQuestions}
                    loadMore={() => this.loadMore('Questions')}
                    count={
                      this.props.questionsResponse.count
                        ? Number(this.props.questionsResponse.count)
                        : 0
                    }
                    query={this.props.query}
                  />
                )}
            </Row>
          )}
        </div>
      </div>
    );
  }
}

export default Search;
